define.alias("shared/utils/string-formatters/remove-underscores", "preview-grid/utils/string-formatters/remove-underscores");